import * as Yup from "yup";

export const deliveryPartnerSchema = Yup.object({
  farmerPartnerId: Yup.string().required("Farmer Partner is required"),

  deliveryPartnerName: Yup.string()
    .required("Delivery Partner Name is required")
    .min(3, "Minimum 3 characters required"),

  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),

  contactNumber: Yup.string()
    .matches(/^[0-9]{10}$/, "Contact Number must be 10 digits")
    .required("Contact Number is required"),

  alternateContactNumber: Yup.string()
    .nullable()
    .test(
      "alt-contact",
      "Alternate Contact Number must be 10 digits",
      (value) => !value || /^[0-9]{10}$/.test(value)
    ),

  addressLine1: Yup.string(),

  addressLine2: Yup.string(),

  village: Yup.string(),

  city: Yup.string(),

  state: Yup.string(),

  pincode: Yup.string()
    .matches(/^[0-9]{6}$/, "Pincode must be 6 digits")
    .required("Pincode is required"),

  landmark: Yup.string(),

  vehicleType: Yup.string(),

  vehicleNumber: Yup.string().matches(
    /^[A-Z]{2}[0-9]{1,2}[A-Z]{1,2}[0-9]{4}$/i,
    "Invalid Vehicle Number"
  ),

  drivingLicenseNumber: Yup.string(),

  drivingLicenseImage: Yup.mixed(),

  //   profileImage: Yup.mixed(),

  notes: Yup.string(),

  isActive: Yup.boolean(),

  isAvailable: Yup.boolean(),
});
